<template>
	<header class="header">
		<div class="header">
			<nav class="navbar is-transparent">
				<div class="navbar-brand">
					<a href="https://netcorecloud.com" class="navbar-item">
						<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/netcore-logo-main.svg" alt="netcore-logo">
					</a>
					<div data-target="netcore-navbar" class="navbar-burger burger">
						<span></span>
						<span></span>
						<span></span>
					</div>
				</div>
				<div id="netcore-navbar" class="navbar-menu">
					<div class="navbar-end">
						<div class="navbar-item has-dropdown is-hoverable is-mega">
						<div data-target="productsDropdown" class="navbar-link is-arrowless flex"> Products </div>
						<div id="productsDropdown" data-style="width: 18rem;" class="navbar-dropdown nav-list-dd">
							<div class="navbar-container nav-grid-cont">
								<div class="links-header-dd">
									<div class="v-spacer-20"></div>
									<a href="https://netcorecloud.com/products/" class="links-header-bigtext hero-tile-action light-blue nav-link-dd"> All Products </a>
									<div class="v-spacer-10"></div>
									<div class="links-header-smalltext"> Discover the Netcore Customer Engagement &amp; Experience Platform </div>
									<div class="v-spacer-20"></div>
								</div>
								<div class="v-spacer-20"></div>
								<div class="content columns">
									<div class="column">
										<div class="content-links">
											<div class="columns">
											<div class="link-section nav-link-dd hover-effect column is-4">
												<a href="https://netcorecloud.com/customer-engagement" class="link-section-header">
												<div class="link-section-header-icon">
													<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/product_tiles/customer-engagement.svg">
												</div>
												<div class="nav-link-dd"> Customer Engagement </div>
												</a>
												<div class="v-spacer-20"></div>
												<div class="link-section-body">
												<a href="https://netcorecloud.com/customer-engagement/journey-orchestration/" class="link-section-body-row">
													<div class="link-section-body-icon">
													<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/journey_orchestration.svg">
													</div>
													<div>Journey Orchestration</div>
												</a>
												<div class="v-spacer-10"></div>
												<a href="https://netcorecloud.com/customer-engagement/multi-channel-marketing/" class="link-section-body-row">
													<div class="link-section-body-icon">
													<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/smart_push_notification.svg">
													</div>
													<div>Multichannel Marketing</div>
												</a>
												<div class="v-spacer-10"></div>
												<a href="https://netcorecloud.com/customer-engagement/behavioral-analytics/" class="link-section-body-row">
													<div class="link-section-body-icon">
													<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/behaviour_analytics.svg">
													</div>
													<div>Behavioral Analytics</div>
												</a>
												<div class="v-spacer-10"></div>
												<a href="https://netcorecloud.com/customer-engagement/" class="hero-tile-action m-0">View all features</a>
												</div>
											</div>
											<div class="link-section nav-link-dd hover-effect column is-4">
												<a href="https://netcorecloud.com/product-experience/" class="link-section-header">
												<div class="link-section-header-icon">
													<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/product_tiles/product-experiences.svg">
												</div>
												<div>Product Experience</div>
												</a>
												<div class="v-spacer-20"></div>
												<div class="link-section-body">
												<a href="https://netcorecloud.com/product-experience/mobile-a-b-testing/" class="link-section-body-row">
													<div class="link-section-body-icon">
													<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/ab_testing.svg">
													</div>
													<div>A/B Testing</div>
												</a>
												<div class="v-spacer-10"></div>
												<a href="https://netcorecloud.com/product-experience/app-walkthroughs-contextual-nudges/" class="link-section-body-row">
													<div class="link-section-body-icon">
													<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/app_walkthrough.svg">
													</div>
													<div>Contextual Nudges</div>
												</a>
												<div class="v-spacer-10"></div>
												<a href="https://netcorecloud.com/product-experience/feature-flags/" class="link-section-body-row">
													<div class="link-section-body-icon">
													<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/user_journey_optimization.svg">
													</div>
													<div>Feature Flags</div>
												</a>
												<div class="v-spacer-10"></div>
												<a href="https://netcorecloud.com/product-experience/" data="" class="hero-tile-action m-0">View all features</a>
												</div>
											</div>
											<div class="link-section nav-link-dd hover-effect column is-4">
												<a href="https://netcorecloud.com/email/" class="link-section-header">
												<div class="link-section-header-icon">
													<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/product_tiles/email.svg">
												</div>
												<div>Email</div>
												</a>
												<div class="v-spacer-20"></div>
												<div class="link-section-body">
												<a href="https://netcorecloud.com/email/email-api/" class="link-section-body-row">
													<div class="link-section-body-icon">
													<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/email_api.svg">
													</div>
													<div>Email API</div>
												</a>
												<div class="v-spacer-10"></div>
												<a href="https://netcorecloud.com/email/email-marketing/" class="link-section-body-row">
													<div class="link-section-body-icon">
													<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/email_marketing.svg">
													</div>
													<div>Email Marketing</div>
												</a>
												<div class="v-spacer-10"></div>
												<!-- <a href="https://netcorecloud.com/email/email-api/artificial-intelligence/" class="link-section-body-row">
													<div class="link-section-body-icon">
													<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/smtp.svg">
													</div>
													<div>Deliverability</div>
												</a> -->
												<a href="https://netcorecloud.com/amp/" class="link-section-body-row">
													<div class="link-section-body-icon">
													<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/smtp.svg">
													</div>
													<div>AMP</div>
												</a>
												<div class="v-spacer-10"></div>
												<a href="https://netcorecloud.com/email/" class="hero-tile-action m-0">View all features</a>
												</div>
											</div>
											</div>
											<div class="v-spacer-20"></div>
											<div class="columns block">
												<div class="link-section hover-effect column is-one-third">
													<a href="https://netcorecloud.com/customer-data-platform/" class="link-section-header">
													<div class="link-section-header-icon">
														<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/product_tiles/cdp.svg">
													</div>
													<div>Customer data platform</div>
													</a>
													<div class="v-spacer-20"></div>
													<div class="link-section-body">
													<a href="https://netcorecloud.com/cdp/unified-customer-view/" class="link-section-body-row">
														<div class="link-section-body-icon">
														<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/unified_customer_view.svg">
														</div>
														<div>Identity Resolution Cloud</div>
													</a>
													<div class="v-spacer-10"></div>
													<a href="https://netcorecloud.com/cdp/identity-resolution/" class="link-section-body-row">
														<div class="link-section-body-icon">
														<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/real_time_customer_insights.svg">
														</div>
														<div>Real Time Customer Insights</div>
													</a>
													<div class="v-spacer-10"></div>
													<a href="https://netcorecloud.com/cdp/marketing-channel-activation/" class="link-section-body-row">
														<div class="link-section-body-icon">
														<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/identity_resolution.svg">
														</div>
														<div>Activate Channel Marketing</div>
													</a>
													<div class="v-spacer-10"></div>
													<a href="https://netcorecloud.com/customer-data-platform/" class="hero-tile-action m-0">View all features</a>
													</div>
												</div>
												<div class="link-section hover-effect column is-one-third">
													<a href="https://netcorecloud.com/personalization/" class="link-section-header">
													<div class="link-section-header-icon">
														<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/product_tiles/personalization.svg">
													</div>
													<div>Personalization</div>
													</a>
													<div class="v-spacer-20"></div>
													<div class="link-section-body">
													<a href="https://netcorecloud.com/personalization/personalized-recommendations/" class="link-section-body-row">
														<div class="link-section-body-icon">
														<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/product_recommendation.svg">
														</div>
														<div>Product Recommendations</div>
													</a>
													<div class="v-spacer-10"></div>
													<a href="https://netcorecloud.com/personalization/product-performance-sales-dashboard/" class="link-section-body-row">
														<div class="link-section-body-icon">
														<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/content_personalization.svg">
														</div>
														<div>Product Performance</div>
													</a>
													<div class="v-spacer-10"></div>
													<a href="https://netcorecloud.com/personalization/search-personalization/" class="link-section-body-row">
														<div class="link-section-body-icon">
														<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/app_personalization.svg">
														</div>
														<div>Search Personalization</div>
													</a>
													<div class="v-spacer-10"></div>
													<a href="https://netcorecloud.com/personalization/" class="hero-tile-action m-0">View all features</a>
													</div>
												</div>
												<div class="link-section hover-effect column is-one-third">
													<a href="https://netcorecloud.com/personalization/" class="link-section-header">
													<div class="link-section-header-icon">
														<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/product_tiles/personalization.svg">
													</div>
													<div>Raman's AI Engine</div>
													</a>
													<div class="v-spacer-20"></div>
													<div class="link-section-body">
													<a href="https://netcorecloud.com/personalization/personalized-recommendations/" class="link-section-body-row">
														<div class="link-section-body-icon">
														<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/product_recommendation.svg">
														</div>
														<div>App churn prediction</div>
													</a>
													<div class="v-spacer-10"></div>
													<a href="https://netcorecloud.com/personalization/content-personalization/" class="link-section-body-row">
														<div class="link-section-body-icon">
														<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/content_personalization.svg">
														</div>
														<div>Intelligent engagement</div>
													</a>
													<div class="v-spacer-10"></div>
													<a href="https://netcorecloud.com/personalization/mobile-app-personalization/" class="link-section-body-row">
														<div class="link-section-body-icon">
														<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/app_personalization.svg">
														</div>
														<div>AI-led image Recognition System</div>
													</a>
													<div class="v-spacer-10"></div>
													<a href="https://netcorecloud.com/personalization/" class="hero-tile-action m-0">View all features</a>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="content-sidelinks column is-one-third">
									<div class="link-section columns">
										<div class="column">
											<div class="link-section-header">
												<div class="link-section-header-icon">
													<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/product_tiles/messaging-channel.svg">
												</div>
												<div>Messaging Channels</div>
											</div>
											<div class="v-spacer-20"></div>
												<div class="link-section-body messaging">
													<a href="https://netcorecloud.com/app-push-notifications/" class="link-section-body-row">
													<div class="link-section-body-icon">
														<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/app_push_notification.svg">
													</div>
													<div>App Push Notifications</div>
													</a>
													<div class="v-spacer-10"></div>
													<a href="https://netcorecloud.com/in-app-messages/" class="link-section-body-row">
													<div class="link-section-body-icon">
														<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/in_app_messages.svg">
													</div>
													<div>In-App Messages</div>
													</a>
													<div class="v-spacer-10"></div>
													<a href="https://netcorecloud.com/web-push-notifications/" class="link-section-body-row">
														<div class="link-section-body-icon">
															<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/web_push_notification.svg">
														</div>
														<div>Web Push Notifications</div>
													</a>
													<div class="v-spacer-10"></div>
													<a href="https://netcorecloud.com/web-messages/" class="link-section-body-row">
													<div class="link-section-body-icon">
														<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/web_messages.svg">
													</div>
													<div>Web Messages</div>
													</a>
													<div class="v-spacer-10"></div>
													<a href="https://netcorecloud.com/email/email-marketing/" class="link-section-body-row">
													<div class="link-section-body-icon">
														<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/email_marketing.svg">
													</div>
													<div>Email</div>
													</a>
													<div class="v-spacer-10"></div>
													<a href="https://netcorecloud.com/sms/" class="link-section-body-row">
													<div class="link-section-body-icon">
														<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/sms.svg">
													</div>
													<div>SMS</div>
													</a>
													<div class="v-spacer-10"></div>
													<a href="https://netcorecloud.com/voice/" class="link-section-body-row">
													<div class="link-section-body-icon">
														<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/voice.svg">
													</div>
													<div>Voice</div>
													</a>
													<div class="v-spacer-10"></div>
													<a href="https://netcorecloud.com/whatsapp-notifications/" class="link-section-body-row">
													<div class="link-section-body-icon">
														<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/products/subrow/whatsapp_notifications.svg">
													</div>
													<div>Whatsapp</div>
													</a>
													<div class="v-spacer-10"></div>
													<a href="https://netcorecloud.com/rcs/" class="link-section-body-row">
														<div>Rich Communication Services</div>
													</a>
													<div class="v-spacer-20"></div>
												</div>
										</div>
									</div>
									</div>
								</div>
							</div>
						</div>
						</div>
						<div class="navbar-item has-dropdown is-hoverable is-mega">
						<div data-target="solutionsDropdown" class="navbar-link is-arrowless flex"> Solutions </div>
						<div id="solutionsDropdown" data-style="width: 18rem;" class="navbar-dropdown nav-list-dd container">
							<div class="navbar-container nav-grid-cont">
							<div class="columns">
								<div class="links-header-dd column">
								<div class="v-spacer-20"></div>
								<a href="https://netcorecloud.com/products/" class="links-header-bigtext hero-tile-action light-blue nav-link-dd"> All Industries </a>
								<div class="v-spacer-10"></div>
								<div class="links-header-smalltext"> See how we are providing solutions across Industries </div>
								<div class="v-spacer-20"></div>
								</div>
								<!-- <div class="images-header-dd column is-one-third">
								<div class="v-spacer-20"></div>
								<div class="images-header-bigtext"> Featured Customers </div>
								<div class="v-spacer-10"></div>
								<div class="images-header-smalltext"> 5000+ Leading brands trust Netcore </div>
								<div class="v-spacer-20"></div>
								</div> -->
							</div>
							<div class="columns">
								<div class="column">
								<div class="v-spacer-20"></div>
								<div class="content-links">
									<div class="links-body columns">
									<a href="https://netcorecloud.com/industry/e-commerce-online-retail/" class="link-section nav-link-dd column is-3">
										<div class="link-section-header-icon">
										<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/online_retail.svg">
										</div>
										<div class="nav-grid-nav-link">E-Commerce &amp; Retail</div>
										<div></div>
										<div class="nav-grid-nav-desc"> Grow conversions and loyalty through personalized app and web shopping </div>
									</a>
									<a href="https://netcorecloud.com/industry/ott/" class="link-section column is-3">
										<div class="link-section-header-icon">
										<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/ott_platform.svg">
										</div>
										<div class="nav-grid-nav-link"> Media and Entertainment </div>
										<div></div>
										<div class="nav-grid-nav-desc"> Deliver relevant content recommendations and omni-channel engagement </div>
									</a>
									<a href="https://netcorecloud.com/industry/travel/" class="link-section column is-3">
										<div class="link-section-header-icon">
										<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/travel.svg">
										</div>
										<div class="nav-grid-nav-link"> Travel and Hospitality </div>
										<div></div>
										<div class="nav-grid-nav-desc"> Maximize bookings through personalized website and mobile app experiences </div>
									</a>
									<a href="https://netcorecloud.com/industries/edtech/" class="link-section column is-3">
										<div class="link-section-header-icon">
										<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/education.svg">
										</div>
										<div class="nav-grid-nav-link"> Edtech </div>
										<div></div>
										<div class="nav-grid-nav-desc"> Create individual learning experiences and guide course completion </div>
									</a>
									</div>
									<div class="links-body columns">
									<a href="https://netcorecloud.com/industry/fantasy-gaming/" class="link-section column is-3">
										<div class="link-section-header-icon">
										<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/fantasy-gaming-icon.svg">
										</div>
										<div class="nav-grid-nav-link"> Fantasy Gaming </div>
										<div></div>
										<div class="nav-grid-nav-desc"> Uplift contest registration and engagement rates through superior user experiences </div>
									</a>
									<a href="https://netcorecloud.com/industries/business-and-financial-services/" class="link-section column is-3">
										<div class="link-section-header-icon">
										<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/broking-icon.svg">
										</div>
										<div class="nav-grid-nav-link"> Business &amp; Financial </div>
										<div></div>
										<div class="nav-grid-nav-desc"> Contextually engage users to increase transaction rates and investment amount </div>
									</a>
									<a href="https://netcorecloud.com/industry/direct-to-consumer/" class="link-section column is-3">
										<div class="link-section-header-icon">
										<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/d2c-solutionns-logo.svg">
										</div>
										<div class="nav-grid-nav-link">Direct to consumer</div>
										<div></div>
										<div class="nav-grid-nav-desc"> Maximize direct conversions on your owned channels </div>
									</a>
									<a href="https://netcorecloud.com/startups/india/apps/" class="link-section column is-3">
										<div class="link-section-header-icon">
										<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/startup-icon.svg">
										</div>
										<div class="nav-grid-nav-link">Startup</div>
										<div></div>
										<div class="nav-grid-nav-desc"> Startups exclusive retention, conversion &amp; engagement program </div>
									</a>
									</div>
								</div>
								<div class="v-spacer-30"></div>
								</div>
								<!-- <div class="image-group grid-style column is-one-third">
								<div class="columns">
									<div class="cust-image column">
									<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/home_carousel_logos/mcdonalds.png">
									</div>
									<div class="cust-image column">
									<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/home_carousel_logos/the-body-shop.png">
									</div>
								</div>
								<div class="columns">
									<div class="cust-image column">
									<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/home_carousel_logos/hotstar.png">
									</div>
									<div class="cust-image column">
									<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/home_carousel_logos/canon.png">
									</div>
								</div>
								<div class="columns">
									<div class="cust-image column">
									<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/home_carousel_logos/jockey.png">
									</div>
									<div class="cust-image column">
									<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/home_carousel_logos/smartfren.png">
									</div>
								</div>
								<div class="columns">
									<div class="cust-image column">
									<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/home_carousel_logos/sssports.png">
									</div>
									<div class="cust-image column">
									<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/home_carousel_logos/gobear.png">
									</div>
								</div>
								</div> -->
							</div>
							</div>
						</div>
						</div>
						<div class="navbar-item has-dropdown is-hoverable is-mega">
							<div data-target="servicesDropdown" class="navbar-link is-arrowless"> Services </div>
							<div id="servicesDropdown" data-style="width: 18rem;" class="navbar-dropdown nav-list-dd container">
								<div class="navbar-container nav-grid-cont">
								<div class="columns">
									<div class="links-header-dd column">
									<div class="v-spacer-20"></div>
									<a href="https://netcorecloud.com/services/" class="links-header-bigtext hero-tile-action light-blue nav-link-dd"> All Services </a>
									<div class="v-spacer-10"></div>
									<div class="links-header-smalltext"> Our extended bouquet of services that helps you increase your conversions and revenues </div>
									<div class="v-spacer-20"></div>
									</div>
									<!-- <div class="images-header-dd column is-one-third">
									<div class="v-spacer-20"></div>
									<div class="images-header-bigtext"> Success Stories </div>
									<div class="v-spacer-10"></div>
									<div class="images-header-smalltext"> Industry data, best practices and product releases </div>
									<div class="v-spacer-20"></div>
									</div> -->
								</div>
								<div class="columns">
									<div class="column">
									<div class="v-spacer-20"></div>
									<div class="content-links">
										<div class="links-body columns">
										<a href="https://netcorecloud.com/email-consultancy/" class="link-section nav-link-dd column is-4">
											<div class="link-section-header-icon">
											<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/deliveryability_service.svg">
											</div>
											<div class="nav-grid-nav-link">Email Consultancy</div>
											<div></div>
											<div class="nav-grid-nav-desc"> Our indigenous CRED - Creative, Reputation, Engagement, Data Segmentation services </div>
										</a>
										<a href="https://netcorecloud.com/industry/ott/" class="link-section column is-4">
											<div class="link-section-header-icon">
											<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/gamechangers.svg">
											</div>
											<div class="nav-grid-nav-link"> Gamechangers </div>
											<div></div>
											<div class="nav-grid-nav-desc"> Drive performance marketing on relevant channels like affiliate, social, email, search and more </div>
										</a>
										<a href="https://netcorecloud.com/infrastructure-security/" class="link-section column is-4">
											<div class="link-section-header-icon">
											<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/mail_infrastructure.svg">
											</div>
											<div class="nav-grid-nav-link"> Infrastructure &amp; Security </div>
											<div></div>
											<div class="nav-grid-nav-desc"> The right communication platform for enterprises that can make all the difference </div>
										</a>
										</div>
									</div>
									<div class="v-spacer-30"></div>
									</div>
									<!-- <div class="image-group grid-style column is-one-third">
									<a href="https://netcorecloud.com/success-story/tvs-credit/" class="image-group flex-style">
										<div class="flex-style-item">
										<div class="fsi-left">
											<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/services_resource.png">
										</div>
										<div class="fsi-right">
											<div class="fsi-text"> TVS Credit achieve 2.2x increase in push notification delivery </div>
										</div>
										</div>
									</a>
									</div> -->
								</div>
								</div>
							</div>
						</div>
						<div class="navbar-item has-dropdown is-hoverable is-mega">
						<div data-target="resourcesDropdown" class="navbar-link is-arrowless"> Resources </div>
						<div id="resourcesDropdown" data-style="width: 18rem;" class="navbar-dropdown nav-list-dd container ">
							<div class="navbar-container nav-grid-cont">
							<div class="columns">
								<div class="links-header-dd column">
								<div class="v-spacer-20"></div>
								<a href="https://netcorecloud.com/resources/" class="links-header-bigtext hero-tile-action light-blue nav-link-dd"> All Resources </a>
								<div class="v-spacer-10"></div>
								<div class="links-header-smalltext"> Industry data, best practices and product releases. </div>
								<div class="v-spacer-20"></div>
								</div>
								<!-- <div class="images-header-dd column is-one-third">
								<div class="v-spacer-20"></div>
								<div class="images-header-bigtext"> Curated resources </div>
								<div class="v-spacer-10"></div>
								<div class="images-header-smalltext"> Industry data, best practices and product releases </div>
								<div class="v-spacer-20"></div>
								</div> -->
							</div>
							<div class="columns">
								<div class="column">
								<div class="v-spacer-20"></div>
									<div class="content-links">
										<div class="links-body columns">
											<a href="https://netcorecloud.com/blog/" class="link-section column is-3">
												<div class="link-section-header-icon">
												<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/blogs.svg">
												</div>
												<div class="nav-grid-nav-link"> Blogs </div>
												<div></div>
												<div class="nav-grid-nav-desc"> Keep yourself updated with all things marketing </div>
											</a>
											<a href="https://netcorecloud.com/resources/success-story/" class="link-section column is-3">
												<div class="link-section-header-icon">
												<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/success_stories.svg">
												</div>
												<div class="nav-grid-nav-link"> Success Stories </div>
												<div></div>
												<div class="nav-grid-nav-desc"> See how netcore helps brands elevate customer experience </div>
											</a>
											<a href="https://netcorecloud.com/resources/ebook/" class="link-section column is-3">
												<div class="link-section-header-icon">
												<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/ebooks.svg">
												</div>
												<div class="nav-grid-nav-link"> Ebooks </div>
												<div></div>
												<div class="nav-grid-nav-desc"> Ebooks, Whitepapers, Reports and more to keep you ahead </div>
											</a>
											<a href="https://netcorecloud.com/events-overview/" class="link-section column is-3">
												<div class="link-section-header-icon">
												<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/events.svg">
												</div>
												<div class="nav-grid-nav-link"> Events </div>
												<div></div>
												<div class="nav-grid-nav-desc"> Unlock secrets, learn, engage and grow </div>
											</a>
										</div>
										<div class="links-body columns">
											<a href="https://netcorecloud.com/resources/podcasts/" class="link-section column is-3">
												<div class="link-section-header-icon">
												<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/podcasts.svg">
												</div>
												<div class="nav-grid-nav-link"> Podcasts </div>
												<div></div>
												<div class="nav-grid-nav-desc"> Leverage insightful conversation with industry leaders </div>
											</a>
											<a href="https://netcorecloud.com/resources/webinars/" class="link-section column is-3">
												<div class="link-section-header-icon">
												<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/webinars.svg">
												</div>
												<div class="nav-grid-nav-link"> Webinars </div>
												<div></div>
												<div class="nav-grid-nav-desc"> Game changing Marketing Insights to stay ahead </div>
											</a>
											<a href="https://netcorecloud.com/resources/videos/" class="link-section column is-3">
												<div class="link-section-header-icon">
												<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/videos.svg">
												</div>
												<div class="nav-grid-nav-link"> Videos </div>
												<div></div>
												<div class="nav-grid-nav-desc"> Get the most out of Netcore with our step-by-step videos </div>
											</a>
											<a href="https://netcorecloud.com/resources/guides/" class="link-section column is-3">
												<div class="link-section-header-icon">
												<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/guides.svg">
												</div>
												<div class="nav-grid-nav-link"> Guides </div>
												<div></div>
												<div class="nav-grid-nav-desc"> Lessons to kickstart and grow your multi-channel marketing </div>
											</a>
										</div>
										<div class="links-body columns">
											<a target="_blank" href="https://netcorecloud.com/resources/interactive-product-demos/" class="link-section column is-3">
												<div class="link-section-header-icon">
													<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/netcore_design.svg">
												</div>
												<div class="nav-grid-nav-link"> Interactive product demos </div>
												<div></div>
												<div class="nav-grid-nav-desc"> Interactive walkthroughs of our features &amp; functionalities </div>
											</a>
											<a target="_blank" href="https://design.netcorecloud.com/" class="link-section column is-3">
												<div class="link-section-header-icon">
													<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/netcore_design.svg">
												</div>
												<div class="nav-grid-nav-link"> Demo Center </div>
												<div></div>
												<div class="nav-grid-nav-desc"> Sneak peak into our suite of marketing automation tools </div>
											</a>
											<a href="https://netcorecloud.com/tools/" class="link-section column is-3">
												<div class="link-section-header-icon">
												<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/tools.svg">
												</div>
												<div class="nav-grid-nav-link"> Tools </div>
												<div></div>
												<div class="nav-grid-nav-desc"> Empower yourself with valuable tools for free </div>
											</a>
											<a target="_blank" href="https://design.netcorecloud.com/" class="link-section column is-3">
												<div class="link-section-header-icon">
													<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/netcore_design.svg">
												</div>
												<div class="nav-grid-nav-link"> Netcore Design </div>
												<div></div>
												<div class="nav-grid-nav-desc"> Behind the scenes of our design team, processes and learnings </div>
											</a>
										</div>
										<!-- <div class="links-body columns">
											<a target="_blank" href="https://netcorecloud.com/tutorials/" class="link-section column is-4">
												<div class="link-section-header-icon">
													<img src="@/assets/img/tutorial/tutorial_icon.svg">
												</div>
												<div class="nav-grid-nav-link"> Tutorial</div>
												<div></div>
												<div class="nav-grid-nav-desc"> Solutions for any product problems </div>
											</a>
										</div> -->
									</div>
									<div class="v-spacer-30"></div>
								</div>
								<!-- <div class="image-group grid-style column is-one-third">
								<a href="https://netcorecloud.com/blog/a-definitive-guide-to-mobile-app-user-retention/" class="image-group flex-style">
									<div class="flex-style-item">
									<div class="fsi-left">
										<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/res_right1.png">
									</div>
									<div class="fsi-right">
										<div class="fsi-text"> A definitive guide to Mobile App User Retention </div>
									</div>
									</div>
								</a>
								<div class="v-spacer-10"></div>
								<a href="https://netcorecloud.com/blog/key-mobile-app-metrics-that-you-must-measure-in-2020/" class="image-group flex-style">
									<div class="flex-style-item">
									<div class="fsi-left">
										<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/res_right2.png">
									</div>
									<div class="fsi-right">
										<div class="fsi-text"> Key Mobile App metrics that you must measure in 2020 </div>
									</div>
									</div>
								</a>
								<div class="v-spacer-10"></div>
								<a href="https://netcorecloud.com/blog/e-commerce-product-recommendation-using-image-recognition/" class="image-group flex-style">
									<div class="flex-style-item">
									<div class="fsi-left">
										<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/res_right3.png">
									</div>
									<div class="fsi-right">
										<div class="fsi-text"> How AI-based Image Recognition can help E-commerce Brands </div>
									</div>
									</div>
								</a>
								<div class="v-spacer-10"></div>
								<a href="https://netcorecloud.com/ebook/contextual-nudges-walkthroughs-the-new-app-retention-catalysts/" class="image-group flex-style">
									<div class="flex-style-item">
									<div class="fsi-left">
										<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/res_right4.png">
									</div>
									<div class="fsi-right">
										<div class="fsi-text"> Contextual Nudges &amp; Walkthroughs: The New App Retention Catalysts </div>
									</div>
									</div>
								</a>
								<div class="v-spacer-10"></div>
								<a href="https://netcorecloud.com/blog/how-online-fashion-retailers-can-leverage-personalization-to-thrive-in-the-new-normal/" class="image-group flex-style">
									<div class="flex-style-item">
									<div class="fsi-left">
										<img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/dropdown/res_right5.png">
									</div>
									<div class="fsi-right">
										<div class="fsi-text"> How Online Fashion Retailers can leverage Personalization </div>
									</div>
									</div>
								</a>
								<div class="v-spacer-10"></div>
								</div> -->
							</div>
							</div>
						</div>
						</div>
						<div class="navbar-item has-dropdown is-hoverable is-mega">
							<div data-target="productsDropdown" class="navbar-link is-arrowless flex"> 
								<a href="https://netcorecloud.com/customers/" class="navbar-link is-arrowless"> Customers </a>
							</div>
						</div>
						<!-- <a href="https://netcorecloud.com/customers/" class="navbar-link is-arrowless"> Customers </a> -->
						<div class="page-sep"></div>
						<a href="https://netcorecloud.com/why-netcore/" class="navbar-link is-arrowless"> Why Netcore? </a>
						<a id="GetDemo" href="https://netcorecloud.com/request-demo/" class="navbar-item is-arrowless button"> Get Started </a>
					</div>
				</div>
			</nav>
			<nav class="navbar navbar-sub-menu">
				<div class="navbar-brand">
					<a href="https://netcorecloud.com" class="navbar-item has-text-dark">
						<!-- <img src="https://netcorecloud.com/wp-content/themes/netcoretheme/assets/images/netcore-logo-main.svg" alt="netcore-logo"> -->
						RESOURCES
					</a>
					<div data-target="netcore-secondary-navbar" class="navbar-burger burger">
						<span></span>
						<span></span>
						<span></span>
					</div>
				</div>
				<div id="netcore-secondary-navbar" class="navbar-menu">
					<div class="navbar-end">
						<div class="navbar-item has-dropdown is-hoverable is-mega">
							<a data-target="Blogs" class="navbar-link is-arrowless flex" href="https://netcorecloud.com/blog"> Blogs </a>
						</div>
						<div class="navbar-item has-dropdown is-hoverable is-mega">
							<a data-target="success_Stories" class="navbar-link is-arrowless flex" href="https://netcorecloud.com/resources/success-story"> Success Stories </a>
						</div>
						<div class="navbar-item has-dropdown is-hoverable is-mega">
							<a data-target="podcasts" class="navbar-link is-arrowless" href="https://netcorecloud.com/resources/podcasts"> Podcasts </a>
						</div>
						<div class="navbar-item has-dropdown is-hoverable is-mega">
							<a data-target="ebooks" class="navbar-link is-arrowless" href="https://netcorecloud.com/resources/ebook"> Ebooks </a>
						</div>
						<div class="navbar-item has-dropdown is-hoverable is-mega">
							<a data-target="videos" class="navbar-link is-arrowless flex" href="https://netcorecloud.com/resources/videos/"> Videos </a>
						</div>
						<div class="navbar-item has-dropdown is-hoverable is-mega">
							<a data-target="events" class="navbar-link is-arrowless flex" href="https://netcorecloud.com/events-overview/"> Events </a>
						</div>
						<div class="navbar-item has-dropdown is-hoverable is-mega">
							<a data-target="guides" class="navbar-link is-arrowless" href="https://netcorecloud.com/resources/guides"> Guides </a>
						</div>
						<div class="navbar-item has-dropdown is-hoverable is-mega">
							<a data-target="webinars" class="navbar-link is-arrowless" href="https://netcorecloud.com/resources/webinars"> Webinars </a>
						</div>
						<div class="navbar-item has-dropdown is-hoverable is-mega">
							<a data-target="webinars" class="navbar-link is-arrowless" href="https://netcorecloud.com/tutorials/"> Tutorials </a>
						</div>
					</div>
				</div>
			</nav>
		</div>
	</header>
</template>

<script>
export default {
  name: 'HeaderPrismic',
	mounted() {
    // Get all "navbar-burger" elements
    const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('div.navbar-burger.burger'), 0);
    // Check if there are any navbar burgers
    if ($navbarBurgers.length > 0) {

			// Add a click event on each of them
			$navbarBurgers.forEach( el => {
			el.addEventListener('click', () => {
				
			// Get the target from the "data-target" attribute
			const target = el.dataset.target;
			const $target = document.getElementById(target);

			// Toggle the "is-active" class on both the "navbar-burger" and the "navbar-menu"
			el.classList.toggle('is-active');
			$target.classList.toggle('is-active');

			});
		});
    }
  },
}
</script>

<style scoped>
@import "../assets/css/tutorial/header.css";
</style>
